export default class Start {
    get(frame) {
        if(frame.num === 0) {
            return [0, 5, 5]
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/episods/all/start.js
 **/